(function () {

  function initSlideshow(blockEl) {
    const track    = blockEl.querySelector('[data-track]');
    const dots     = blockEl.querySelectorAll('[data-dot]');
    const prevBtn  = blockEl.querySelector('[data-prev]');
    const nextBtn  = blockEl.querySelector('[data-next]');

    if (!track) return;

    const total        = parseInt(blockEl.dataset.total);
    const infinite     = blockEl.dataset.infinite === 'true';
    const autoplay     = blockEl.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(blockEl.dataset.autoplayDelay) || 4000;

    // Disable all interaction when only one slide exists
    if (total <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      const pagination = blockEl.querySelector('[data-pagination]');
      if (pagination) pagination.style.display = 'none';
      track.style.cursor = 'default';
      return;
    }

    let current      = 0;
    let autoplayTimer = null;
    let isDragging   = false;
    let wasDragged   = false;
    let dragStartX   = 0;
    let dragDelta    = 0;
    let clonesBefore = 0;

    // ── Infinite loop: clone first/last slides ────────────────
    if (infinite) {
      const slides      = Array.from(track.children);
      const firstClones = slides.slice(0, 2).map(s => s.cloneNode(true));
      const lastClones  = slides.slice(-2).map(s => s.cloneNode(true));

      lastClones.reverse().forEach(clone => {
        clone.setAttribute('aria-hidden', 'true');
        track.prepend(clone);
      });

      firstClones.forEach(clone => {
        clone.setAttribute('aria-hidden', 'true');
        track.append(clone);
      });

      clonesBefore = lastClones.length;
      current = clonesBefore;
    }

    // ── Navigate to a slide index ─────────────────────────────
    function goTo(index, animate = true) {
      track.style.transition = animate ? 'transform 0.5s ease' : 'none';
      track.style.transform  = `translateX(-${index * 100}%)`;
      current = index;
      updateDots();
    }

    // ── Silently reset position at clone boundaries ───────────
    track.addEventListener('transitionend', () => {
      if (!infinite) return;
      const realTotal = total + clonesBefore;
      if (current >= realTotal)  goTo(clonesBefore, false);
      if (current < clonesBefore) goTo(realTotal - clonesBefore, false);
    });

    // ── Sync pagination dots to real slide index ──────────────
    function updateDots() {
      if (!dots.length) return;
      let realIndex = current - clonesBefore;
      if (realIndex < 0)       realIndex = total - 1;
      if (realIndex >= total)  realIndex = 0;
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === realIndex));
    }

    // ── Arrow buttons ─────────────────────────────────────────
    function goPrev() { goTo(current - 1); resetAutoplay(); }
    function goNext() { goTo(current + 1); resetAutoplay(); }

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    // ── Pagination dot clicks ─────────────────────────────────
    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.dataset.dot) + clonesBefore);
        resetAutoplay();
      });
    });

    // ── Autoplay ──────────────────────────────────────────────
    function startAutoplay() {
      if (!autoplay) return;
      autoplayTimer = setInterval(goNext, autoplayDelay);
    }

    function resetAutoplay() {
      clearInterval(autoplayTimer);
      startAutoplay();
    }

    startAutoplay();

    // ── Touch swipe ───────────────────────────────────────────
    let touchStartX = 0;

    blockEl.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });

    blockEl.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goNext() : goPrev();
        resetAutoplay();
      }
    });

    // ── Mouse drag ────────────────────────────────────────────
    track.addEventListener('mousedown', e => {
      isDragging  = true;
      wasDragged  = false;
      dragStartX  = e.clientX;
      dragDelta   = 0;
      track.style.transition = 'none';
      track.style.cursor     = 'grabbing';
      track.querySelectorAll('img').forEach(img => img.style.pointerEvents = 'none');
      e.preventDefault();
    });

    window.addEventListener('mousemove', e => {
      if (!isDragging) return;
      dragDelta = dragStartX - e.clientX;
      if (Math.abs(dragDelta) > 5) wasDragged = true;
      const dragPercent = (dragDelta / track.offsetWidth) * 100;
      track.style.transform = `translateX(calc(-${current * 100}% - ${dragPercent}%))`;
    });

    window.addEventListener('mouseup', () => {
      if (!isDragging) return;
      isDragging = false;
      track.style.cursor = 'grab';
      track.querySelectorAll('img').forEach(img => img.style.pointerEvents = '');
      Math.abs(dragDelta) > 80 ? (dragDelta > 0 ? goNext() : goPrev()) : goTo(current);
      resetAutoplay();
    });

    // Suppress click after a real drag to prevent link navigation
    track.addEventListener('click', e => {
      if (!wasDragged) return;
      e.preventDefault();
      e.stopPropagation();
      wasDragged = false;
    }, true);

    track.style.cursor = 'grab';

    // ── Set initial position ──────────────────────────────────
    goTo(current, false);
  }

  // ── Boot: init all slideshows on the page ────────────────────
  function initAll() {
    document.querySelectorAll('.slideshow-hero-block').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify theme editor block selection
  document.addEventListener('shopify:block:select', e => {
    const block = e.target.closest('.slideshow-hero-block');
    if (block) initSlideshow(block);
  });

})();